import React, { useEffect } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { Get } from 'src/apis/apiWithType'
import { InputField, Select } from 'src/components/UI'
import { useJobLevels } from 'src/pages/basic-information/JobLevels/hooks'
import { useShipTypes } from 'src/pages/basic-information/ShipTypes/hooks'
import { CrewDataMutateType, Job, ListResponseType, ResponseType } from 'src/types'

export const WorkInfo = () => {

    const { t } = useTranslation()

    const { isLoading: shipTypeLoading, data: shipTypeData } = useShipTypes()

    const { isLoading: levelLoading, data: levelData } = useJobLevels()

    const { isLoading: jobsLoading, data: jobsData } = useQuery<ListResponseType<Job>>({
        queryFn: () => Get('basic-information/job/')
    })

    const { register, formState: { errors }, getValues, watch, resetField, control } = useFormContext<CrewDataMutateType>()

    const errorGenertor = (key: keyof CrewDataMutateType) => ({ error: !!errors?.[key], errorText: errors?.[key]?.message })

    const errorText = (title: string) => `${title} ${t('IsRequired')}`

    const lng = useSelector((state) => (state as any).common.lng)

    const level_id = watch('level_id')

    useEffect(() => {
        resetField('job_id')
    }, [level_id])


    const booleanFileds: Array<{ key: keyof CrewDataMutateType, titleKey: string }> = [
        { key: 'excontiner', titleKey: 'ExperinceInContainer' },
        { key: 'exbulk', titleKey: 'ExperinceInBulk' },
        { key: 'exfueled', titleKey: 'ExperinceInFueled' },
        { key: 'exlandycraft', titleKey: 'ExperinceInLandyCraft' }]


    return (
        <div className='flex flex-col  gap-3 bg-white p-4 rounded-lg border '>

            <span className='font-semibold'>{t('WorkInfo')}</span>

            <div className='grid col-span-1 lg:grid-cols-4  items-end gap-6'>



                <div className='col-span-1'>
                    <Select
                        label={t('shipType')}
                        {...register('ship_type_id', { required: { value: true, message: errorText(t('shipType')) } })}
                        {...errorGenertor('ship_type_id')}
                        options={shipTypeData?.details.data.data.map(i => ({ label: lng == 'fa' ? i.fa_name : i.en_name, value: i.id }))}
                        loading={shipTypeLoading}
                        unselectedLabel={`-- ${t('shipType')} --`}
                    />
                </div>

                <div className='col-span-1'>
                    <Select
                        label={t('JobLevel')}
                        {...register('level_id', { required: { value: true, message: errorText(t('JobLevel')) } })}
                        {...errorGenertor('level_id')}
                        options={levelData?.details.data.data.map(i => ({ label: lng == 'fa' ? i.fa_name : i.en_name, value: i.id }))}
                        loading={levelLoading}
                        unselectedLabel={`-- ${t('JobLevel')} --`}
                    />
                </div>

                <div className='col-span-1'>
                    <Select
                        label={t('work')}
                        {...errorGenertor('job_id')}
                        disabled={!level_id}
                        {...register('job_id', { required: { value: true, message: errorText(t('work')) } })}
                        options={jobsData?.details.data.data.map(i => ({ label: i.name, value: i.id }))}
                        loading={jobsLoading}
                        unselectedLabel={!level_id ? t('SelectJobLevelFirst') : `-- ${t('work')} --`}
                    />
                </div>
                <div className='col-span-1'>
                

                    <InputField
                        label={`${t('CareerType')} (${t('Optional')})`}
                        {...register('career_type', { required: { value: false, message: errorText(t('CareerType')) } })}
                        {...errorGenertor('career_type')}
                    />
                </div>

                <div className='col-span-1 lg:col-span-3 flex flex-row gap-8 flex-wrap'>

                    <span className='text-sm text-gray-800'>{t('WorkExperience')} <span className='text-gray-300 text-sm'> &nbsp;({t('Optional')})</span></span>



                    {booleanFileds.map(item =>
                        <Controller
                            control={control}
                            name={item.key}
                            render={({ field: { onChange, value } }) => <label className='flex flex-row gap-2 items-center text-gray-700 text-sm cursor-pointer'>
                                <input type='checkbox' className='rounded' checked={!!value} onChange={({ target: { checked } }) => onChange({ target: { value: !!checked ? 1 : 0 } })} />
                                <span className='mt-0.5'>{t(item.titleKey)}</span>
                            </label>}
                        />
                    )}


                </div>

            </div>

        </div>
    )
}
